import { render, staticRenderFns } from "./permissionsBusinessUnits.vue?vue&type=template&id=13306628&scoped=true&"
import script from "./permissionsBusinessUnits.vue?vue&type=script&lang=js&"
export * from "./permissionsBusinessUnits.vue?vue&type=script&lang=js&"
import style0 from "./permissionsBusinessUnits.vue?vue&type=style&index=0&id=13306628&prod&lang=less&scoped=true&"
import style1 from "./permissionsBusinessUnits.vue?vue&type=style&index=1&id=13306628&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13306628",
  null
  
)

export default component.exports